// extracted by mini-css-extract-plugin
export default {"root":"platform-select_root__SG6F9","icon":"platform-select_icon__bQ2+2","value-icon":"platform-select_value-icon__NfvxZ","item":"platform-select_item__hjy0n"};